/**
 * Exposes the "create()" method on the viewer. Alternative to simply calling `await new WebViewer(options);`
 * @param WebViewer
 */
export function initCreate (WebViewer) {
  WebViewer.create = async function create (options) {
    const viewer = new WebViewer(options);
    await viewer.start(options.el);
    return viewer;
  };
}



// WEBPACK FOOTER //
// ./src/viewer/core/global-api/create.js